import { images } from "../../assets/images";


export const solveSupportTool = {
  id: "doubt-solver",
  title: "Doubt Solver",
  description:
  "Upload student queries or handwriting to get instant step-by-step explanations and hints.",
  ctaLabel: "Open Dashboard →",
  iconSrc: images.doubtSolverFeatured,
  href: "#doubt-solver",
  theme: "orange"
};